import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreateOrderComponent } from './create-order.component';
import { BeneficiarySelectionComponent } from 'src/app/pages/orders/shared/components/create-order/beneficiary-selection/beneficiary-selection.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppMaterialModule } from 'src/app/app-material.module';
import { CurrencyMaskInputMode, NgxCurrencyModule } from 'ngx-currency';
import { DocumentsOrderComponent } from 'src/app/pages/orders/shared/components/create-order/documents-order/documents-order.component';
import { DirectivesModule } from '../../directives/directives.module';
import { CreateOrderConfirmComponent } from 'src/app/pages/orders/shared/components/create-order/create-order-confirm/create-order-confirm.component';
import { FinalitySelectionComponent } from 'src/app/pages/orders/shared/components/create-order/finality-selection/finality-selection.component';
import { CreateOrderConfirmQuotationComponent } from 'src/app/pages/orders/shared/components/create-order/create-order-confirm-quotation/create-order-confirm-quotation.component';
import { CurrencySelectionComponent } from 'src/app/pages/orders/shared/components/create-order/currency-selection/currency-selection.component';
import { ConfirmInfoComponent } from 'src/app/pages/orders/shared/components/create-order/confirm-info/confirm-info.component';
import { SenderSelectionComponent } from 'src/app/pages/orders/shared/components/create-order/sender-selection/sender-selection.component';
import { UpdateOrderComponent } from '../update-order/update-order.component';
import { DocumentsOrderInboundComponent } from 'src/app/pages/orders/shared/components/create-order/documents-order-inbound/documents-order-inbound.component';
import { CreateOrderSuccessInboundComponent } from 'src/app/pages/orders/shared/components/create-order/create-order-success-inbound/create-order-success-inbound.component';
import { PaymentSucessInboundComponent } from 'src/app/pages/orders/shared/components/create-order/payment-sucess-inbound/payment-sucess-inbound.component';
import { FinalitySelectionInboundComponent } from 'src/app/pages/orders/shared/components/create-order/finality-selection-inbound/finality-selection-inbound.component';

export const customCurrencyMaskConfig = {
  align: 'left',
  allowNegative: true,
  allowZero: true,
  decimal: ',',
  precision: 2,
  prefix: '',
  suffix: '',
  thousands: '.',
  nullable: true,
  min: null,
  max: null,
  inputMode: CurrencyMaskInputMode.FINANCIAL,
};

@NgModule({
  declarations: [
    CreateOrderComponent,
    FinalitySelectionComponent,
    FinalitySelectionInboundComponent,
    CurrencySelectionComponent,
    CreateOrderSuccessInboundComponent,
    ConfirmInfoComponent,
    PaymentSucessInboundComponent,
    SenderSelectionComponent,
    UpdateOrderComponent,
    DocumentsOrderInboundComponent,
    BeneficiarySelectionComponent,
    DocumentsOrderComponent,
    CreateOrderConfirmComponent,
    CreateOrderConfirmQuotationComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AppMaterialModule,
    NgxCurrencyModule.forRoot(customCurrencyMaskConfig),
    DirectivesModule,
    AppMaterialModule,
  ],
  exports: [
    CreateOrderComponent,
    UpdateOrderComponent,
    FinalitySelectionComponent,
    FinalitySelectionInboundComponent,
    BeneficiarySelectionComponent,
    DocumentsOrderComponent,
    CreateOrderConfirmQuotationComponent,
  ],
})
export class CreateOrderModule {}
